/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_ANNOUNCEMENT_URL, COMMON_HEADER_CONFIG} from "src/config";

class MetaDataService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListMetaData = (param) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data`,
        params: param,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListMetaDataType = (param) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data`,
        params: param,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneMetaData = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createMetaData = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_ANNOUNCEMENT_URL}/meta-data`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateMetadata = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PUT",
        url: `${API_ANNOUNCEMENT_URL}/meta-data/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteMetadata = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_ANNOUNCEMENT_URL}/meta-data/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: {ids: [id]}
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(id);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const metaDataService = new MetaDataService();

export default metaDataService;
